/**
 * @module core/logger
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const LOGGER_CONSTANTS = {
  EVENT_TYPE: 'payload',
  EVENT_SUB_TYPE: 'log',
  PAYLOAD_TYPE: 'json',
};
